import { frameLoader } from '../embeds/frames';
import { h, render } from 'preact';
import { max } from 'd3';
import * as moment from 'moment';

// data
import data from '../../../data/data.json';
import turnout_dem_by_day from '../../../data/turnout_data/turnout_dem_by_day.json';
import turnout_rep_by_day from '../../../data/turnout_data/turnout_rep_by_day.json';
import turnout_dem_final from '../../../data/turnout_data/turnout_dem_final.json';
import turnout_rep_final from '../../../data/turnout_data/turnout_rep_final.json';

// components
import BarChart from '../components/BarChart';

let statewideData = data.statewide,
  statewideMax = max(data.statewide, d => d['registered_voters']);

let gridClass = 'three-column',
  toggle = data.toggles,
  repTurnout2022,
  demTurnout2022;

if (toggle.is_election_over == 'NO') {
  ////////////// GET LATEST REP DATA
  let dateObjRep = [];
  Object.keys(turnout_rep_by_day[0].results).forEach(r => {
    dateObjRep.push({
      date: r,
      formatted_date: moment(r),
    });
  });
  let latestDateRep = dateObjRep.find(
    d => d.formatted_date == max(dateObjRep, d => d.formatted_date)
  ).date;

  repTurnout2022 = parseInt(
    turnout_rep_by_day[0].results[latestDateRep].county_results[
      'TOTAL'
    ].cumulative_votes_in_person_and_mail.replaceAll(',', '')
  );

  ////////////// GET LATEST DEM DATA
  let dateObjDem = [];
  Object.keys(turnout_dem_by_day[0].results).forEach(r => {
    dateObjDem.push({
      date: r,
      formatted_date: moment(r),
    });
  });
  let latestDateDem = dateObjDem.find(
    d => d.formatted_date == max(dateObjDem, d => d.formatted_date)
  ).date;

  demTurnout2022 = parseInt(
    turnout_dem_by_day[0].results[latestDateDem].county_results[
      'TOTAL'
    ].cumulative_votes_in_person_and_mail.replaceAll(',', '')
  );
} else if (toggle.is_election_over == 'YES') {
  repTurnout2022 = turnout_rep_final.reduce(function(a, b) {
    return a + b.total_votes;
  }, 0);
  demTurnout2022 = turnout_dem_final.reduce(function(a, b) {
    return a + b.total_votes;
  }, 0);
}

////////////// SUB IN 2022 DATA
statewideData.forEach(d => {
  if (d.year == 2022) {
    d.republican = repTurnout2022;
    d.democratic = demTurnout2022;
    d.didnotvote = d.didnotvote - (d.republican + d.democratic);
  }
});

////////////// SORT DATA
statewideData = statewideData.sort(function(a, b) {
  return a.year - b.year;
});

////////////// CHECK TOGGLE IF WE SHOULD DISPLAY 2022 DATA
// if (toggle.is_there_sos_data == 'NO') {
//   statewideData = statewideData.filter(yearData => yearData.year != 2022);
//   gridClass = 'two-column';
// }
// if (toggle.is_there_sos_data == 'YES') {
//   gridClass = 'three-column';
// }

////////////// GENERATE CHARTS
const statewideCharts = statewideData.map(yearData => {
  return (
    <div id={`statewide-${yearData.year}`} class="graphic">
      <BarChart
        yearData={yearData}
        statewideMax={statewideMax}
        base={'.graphic'}
        toggle={toggle}
      />
    </div>
  );
});

render(
  <div id="statewide-charts-container" class={gridClass}>
    {statewideCharts}
  </div>,
  document.getElementById('statewide-charts')
);

// included in index.html by default
// initiates frame so your graphic is wrapped in an AMP-compatible iframe
// renderGraphic() renders a coded graphic on load and on resize
frameLoader();
